import { useState } from 'react';
import toast from 'react-hot-toast';
import { eventsAPI } from '../api/client';
import type { UpcomingEvent } from '../types';

const LABELS: Record<string, string> = {
  going: 'Going',
  not_going: 'Not going',
};

export default function EventRsvpButtons({
  event,
  onChanged,
}: {
  event: UpcomingEvent;
  onChanged?: (status: string) => void;
}) {
  const [status, setStatus] = useState(event.my_rsvp || '');
  const [saving, setSaving] = useState(false);

  if (event.kind === 'member_meeting') return null;

  const choose = async (next: 'going' | 'not_going') => {
    if (saving || status === next) return;
    setSaving(true);
    try {
      await eventsAPI.rsvpOccurrence({
        eventId: event.id,
        scheduleId: event.schedule,
        date: event.occurrence_date,
        status: next,
      });
      setStatus(next);
      onChanged?.(next);
    } catch {
      toast.error('Could not save your RSVP.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="flex items-center gap-1.5">
      <span className="sr-only">
        Will you attend on{' '}
        {new Date(event.starts_at).toLocaleDateString(undefined, { month: 'long', day: 'numeric' })}?
      </span>
      {(['going', 'not_going'] as const).map((value) => {
        const selected = status === value;
        return (
          <button
            key={value}
            type="button"
            disabled={saving}
            onClick={() => void choose(value)}
            className={`px-2.5 py-1 pointer-coarse:px-3 pointer-coarse:py-3 rounded-lg text-xs font-semibold transition disabled:opacity-50 ${
              selected
                ? value === 'going'
                  ? 'bg-green-600 text-white'
                  : 'bg-gray-600 text-white'
                : 'border border-gray-300 text-gray-600 hover:bg-off-white'
            }`}
          >
            {LABELS[value]}
          </button>
        );
      })}
    </div>
  );
}
